<template>
  <div class="no-company-wrapper">
    <img class="logo" :src="`/images/logo-font-${isDark ? 'white' : 'black'}.svg`" alt="Logo yuzu" />
    <h2 v-text="$t('app.form.noCompany.title')" />
    <VField class="form" rules="required|min:2|max:50" icon="bi-building" :label="$t('app.form.register.company')" :placeholder="'Yuzu'" name="companyName"  v-model="state.companyName" :required="true"></VField>
    <Button class="primary create-button" @click="createCompany" :label="$t('app.form.noCompany.createButton')"></Button>
  </div>
</template>

<style lang="scss" scoped>
  .no-company-wrapper {
    display: flex;
    flex-direction: column;
    //align-items: center;
    justify-content: center;

    margin: auto;
    min-height: 100vh;
    width: 40%;
    max-width: 718px;
  }

  .create-button {
    margin-top: 20px;
  }

  .logo {
    margin: 16px 0;
    width: 100px;
  }

  .form {
    margin-top: 0.5rem;
  }
</style>

<script setup lang="ts">
import Button from '@/components/global/Button.vue';
import VField from '@/components/global/VField.vue';
import { useCreateOrganisation } from '@/queries/organisation.query';
import { useDark } from '@vueuse/core';
import { useToast } from 'vue-toastification';

const toast = useToast();
const router = useRouter();
const isDark = useDark();

const { mutateAsync: createOrganisation } = useCreateOrganisation();

const state = reactive({
  companyName: '',
});

async function createCompany() {
  // Here you would typically call an API to create the company
  await createOrganisation({
    name: state.companyName,
  }, {
    onSuccess: (data) => {
      const routeToPush = {
        name: "home",
        params: { companyId: data.company_id },
      };
      try {
        router.push(routeToPush);
      } catch (err) {
        console.error(err)
      }
    },
    onError: (error) => {
      toast.error(getError(error));
    }
  });
}

</script>